function modifyImageUrl(url, size) {
  if (size === null) {
    return url;
  }

  const imageMatch = url.match(
    /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i
  );
  if (imageMatch) {
    const baseUrl = url.split(imageMatch[0]);

    const extension = imageMatch[1];
    return `${baseUrl[0]}.${extension}?width=${size}&height=${size}`;
  }

  return null;
}

const EN_PRODUCT_TITLE_CACHE = new Map();

function getEnglishProductUrlFromHandle(handle) {
  return `${window.location.origin}/products/${handle}`;
}

async function fetchEnglishProductMetaByHandle(handle) {
  if (EN_PRODUCT_TITLE_CACHE.has(handle)) {
    return EN_PRODUCT_TITLE_CACHE.get(handle);
  }

  const url = getEnglishProductUrlFromHandle(handle);

  const promise = fetch(url, { credentials: "same-origin" })
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      const metaScript = doc.querySelector(
        'script[type="application/json"][data-product-meta]'
      );

      if (!metaScript) return null;

      try {
        const meta = JSON.parse(metaScript.textContent);
        return {
          title: meta.title || null,
          handle: meta.handle || null,
        };
      } catch {
        return null;
      }
    })
    .catch((err) => {
      console.error("Failed to fetch EN product meta:", handle, err);
      return null;
    });

  EN_PRODUCT_TITLE_CACHE.set(handle, promise);
  return promise;
}
